import  React from "react";
import { SystemContext } from "./SystemContext";

export default function WithSystem(Component) {

  
  return function SystemComponent(props) {

    return (
      <SystemContext.Consumer>
        {contexts => <Component {...props} {...contexts} />}
      </SystemContext.Consumer>
    );
  };
}
